<div class="card" *ngIf="!registrationSuccessful">
  <div class="card-body">
    <app-form-field-text
      [field]="emailControl"
      label="label.email"
    ></app-form-field-text>
    <app-form-field-text
      [field]="firstnameControl"
      label="label.firstname"
    ></app-form-field-text>
    <app-form-field-text
      [field]="lastnameControl"
      label="label.lastname"
    ></app-form-field-text>
    <app-form-field-password
      [field]="passwordControl"
      label="label.password"
    ></app-form-field-password>
    <app-form-field-password
      [field]="passwordRepeatControl"
      label="label.passwordRepeat"
    ></app-form-field-password>
    <app-form-field-checkbox-gdpr
      class="spacerBottom"
      [field]="confirmedGDPRControl"
    ></app-form-field-checkbox-gdpr>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      (click)="submit()"
      class="btn btn-primary"
    >
      {{ 'label.register' | translate }}
    </button>
  </div>
</div>
<div class="card" *ngIf="registrationSuccessful">
  <div class="card-body">
    <div class="d-flex">
      <div class="flex-1">
        {{ 'message.registration-successful' | translate }}
      </div>
      <button
        class="btn btn-primary"
        (click)="login()"
      >
        {{ 'button.to-login' | translate }}
      </button>
    </div>
  </div>
</div>
